// removed by extract-text-webpack-plugin
module.exports = {"logo":"_20Jp","dragon":"AFTs","r1":"_3j_b","l1":"_26pe","r2":"_1Fxd","l2":"_7ELJ","r3":"_9lMe","l3":"_1JBw","r4":"_3aQ-","l4":"_2aGx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/logo/index.less
// module id = 262
// module chunks = 0